import bus from "helpers/bus";
import jstz from "jstimezonedetect";
import _ from "underscore";

import api from "@/helpers/api";

export default {
  state: {
    current: {
      id: null,
      metadata: {
        context: {
          title: "",
          image: ""
        }
      },
      formdata: {},
      test_mode: false
    }
  },

  mutations: {
    setConversation(state, convo) {
      state.current = convo;
    },

    clearConversation(state) {
      state.current = {
        id: null,
        metadata: {
          context: {
            title: "",
            image: ""
          }
        },
        formdata: {}
      };
    }
  },

  actions: {
    fetchOrCreateConversation({dispatch, commit, rootState}) {
      return api
        .instance()
        .get("/public/v1/conversations", {
          params: {}
        })
        .then((resp) => {
          const convo = _.find(resp.data.data, (c) => {
            return c.attributes.status !== "closed" && c.attributes.uid === rootState.options.options.uid;
          });

          if (convo) {
            commit("setConversation", convo.attributes);
            dispatch("setMessagesConversationId", convo.attributes.id);

            // Get the messages from included data
            const messageIds = _.map(convo.relationships.messages.data, (m) => {
              return m.id;
            });
            let messages = _.filter(resp.data.included, (obj) => {
              return obj.type === "messages" && _.contains(messageIds, obj.id);
            });

            // No messages yet - send initial message
            if (messages.length === 0) {
              dispatch("sendInitialMessage");

              // Messages already exist, sort and append them
            } else {
              messages = _.sortBy(messages, (m) => {
                return m.attributes.created_at;
              });
              _.each(messages, (m) => {
                dispatch("addMessage", {message: m, queue: false});
              });
            }
          } else {
            dispatch("createConversation");
          }
        })
        .catch((err) => {
          bus.$emit("connectionError", err, "Failed to fetch conversations");
        });
    },

    createConversation({commit, dispatch, rootState}) {
      const tz = jstz.determine().name();

      api
        .instance()
        .post("/public/v1/conversations", {
          timezone: tz,
          uid: rootState.options.options.uid,
          context: {...rootState.options.options.context, referer: window.location.href, cookies: Object.fromEntries(document.cookie.split('; ').filter(k => k.startsWith('_ga')).map(x => x.split('=')))},
          test_mode: rootState.options.options.testMode || false
        })
        .then((resp) => {
          commit("setConversation", resp.data.data.attributes);
          dispatch("setMessagesConversationId", resp.data.data.attributes.id);
          dispatch("sendInitialMessage");
        })
        .catch((err) => {
          bus.$emit("connectionError", err, "Failed to create conversation");
        });
    },

    reset({dispatch}) {
      dispatch("fetchOrCreateConversation");
    }
  }
};
